import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { getCurrentAccount } from "../../accounts/accounts.reducer";
import { catchError, switchMap, take } from "rxjs/operators";
import { LANG } from "../../app.component";
import { ToastrTranslatedService } from "../toastr-translated.service";

@Injectable()
export class CurrentDomainInterceptor implements HttpInterceptor {
  constructor(
    private toastr: ToastrTranslatedService,
    private readonly store: Store,
    private readonly translate: TranslateService,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return this.store.select(getCurrentAccount).pipe(
      take(1),
      switchMap((currentAccount) => {
        const headers = {} as Record<string, string>;

        if (currentAccount) {
          headers.domain = currentAccount;
        }

        const language = (
          localStorage.getItem(LANG) ||
          this.translate.currentLang ||
          this.translate.defaultLang ||
          "en"
        )
          .trim()
          .toLowerCase()
          .split(/[-_]/)[0];
        if (language === "pl" || language === "es" || language === "en") {
          headers["x-app-language"] = language;
        }

        const apiReq = request.clone({
          setHeaders: headers,
        });
        return next
          .handle(apiReq)
          .pipe(catchError((err) => this.serviceError(err)));
      }),
    );
  }

  private serviceError(e: unknown) {
    console.error(e);
    const error = e as HttpErrorResponse;
    const shouldShowGenericError = error.status === 0 || error.status >= 500;
    if (shouldShowGenericError) {
      this.toastr.error("error");
    }
    return throwError(() => e);
  }
}
